export default __webpack_public_path__ + "4fed56759222f700991ba269bda50897.png";